import React, { useEffect, useState } from 'react';
import Page from 'components/Page';
import { api } from 'app';
import styled from 'styled-components';
import Table from 'components/kit/Table';
import Tooltip from 'packages/ui/Tooltip';
import Button from 'packages/ui/Button';
import { variables } from 'styled-up';
import BaseAlert from 'packages/ui/Alert';

function EventNotifications({ eventId }) {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [submittingMsg, setSubmittingMsg] = useState(false);

  useEffect(() => {
    api.get(`adminPanel/events/${eventId}/notifications`).then(res => {
      setData(res.body);
      setLoading(false);
    });
  }, []);

  const Dot = styled.span`
    height: 25px;
    width: 25px;
    background-color: ${props => (props.mood ? variables.color.success : variables.color.tertiary)};
    border-radius: 50%;
    display: inline-block;
  `;

  const labels = {
    notified_followers: 'ایمیل به دنبال کنندگان برگزارکننده (ارسال بعد از خرید اولین بلیت)',
    notified_reminding: 'پیامک و ایمیل یادآوری',
    notified_webinar_link: 'پیامک و ایمیل ورود به وبینار (۳۰ دقیقه قبل از وبینار)'
  };

  const APIUrls = {
    notified_followers: 'notified-followers',
    notified_reminding: 'notified-reminding',
    notified_webinar_link: 'notified-webinar-link'
  };

  const handleClick = key => {
    data[key] = !data[key];
    api.post(`adminPanel/events/${eventId}/notifications/${APIUrls[key]}`, data).then(res => {
      setSubmittingMsg('درخواست شما با موفقیت ثبت گردید.');
    });
  };

  const PaddedPage = styled.div`
    padding-top: 30px;
  `;

  return (
    <Page>
      <PaddedPage>
        {!loading && (
          <Table>
            <tbody>
              {!!data &&
                Object.keys(data).map((key, index) => (
                  <tr key={index}>
                    <td width="10%">
                      <Tooltip
                        description={
                          data[key] ? 'ارسال شده یا\n توسط پشتیبانی لغو شده' : 'هنوز ارسال نشده'
                        }
                      >
                        <Dot mood={data[key]} />
                      </Tooltip>
                    </td>
                    <td width="30%">
                      <h5>{labels[key]}</h5>
                    </td>
                    <td width="10%">
                      {!data[key] && (
                        <Button
                          type="button"
                          mood="error"
                          className="me-5"
                          onClick={() => handleClick(key)}
                        >
                          ارسال نشود
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
        {submittingMsg && (
          <BaseAlert mood="info" title={submittingMsg}>
            {submittingMsg}
          </BaseAlert>
        )}
      </PaddedPage>
    </Page>
  );
}

export default EventNotifications;
